import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import TopBar from "@/components/TopBar";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import Partners from "@/components/Partners";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import AnnouncementModal from "@/components/AnnouncementModal";

const LandingPage = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to hash whenever the hash changes (e.g., from blog -> /#contact, or first load with hash)
    if (location.hash) {
      const id = location.hash.slice(1);
      // Wait for the sections to mount before scrolling
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 80);
      return () => clearTimeout(t);
    }
  }, [location.hash, location.key]);

  return (
    <div data-testid="landing-page">
      <SEO />
      <AnnouncementModal />
      <TopBar />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Gallery />
        <Testimonials />
        <Partners />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
